module.exports = __webpack_public_path__ + "img/tangjin.82dc67fa.jpg";